import React from "react";
import Box from "@mui/material/Box";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import PropTypes from "prop-types";
import {LinkTextButton} from "./LinkTextButton";

/**
 * A box with a message and a link button.
 *
 * @param {Object} props Component props
 * @param {string} props.message The message to display
 * @param {string} props.linkText The text for the link button
 * @param {string} props.linkUrl The link for the link button
 * @returns {React.ReactElement} The component
 */
const LevelOneMessageDetails = ({message, linkText, linkUrl}) => {
    return <Box sx={{
        padding: '8px',
        border: '1px solid #ddd',
    }}>
        {message}
        <LinkTextButton endIcon={<OpenInNewIcon/>} text={linkText} url={linkUrl}/>
    </Box>;
};

LevelOneMessageDetails.propTypes = {
    message: PropTypes.string.isRequired,
    linkText: PropTypes.string.isRequired,
    linkUrl: PropTypes.string.isRequired
};

export {LevelOneMessageDetails};